import React from 'react';
import { CompassIcon } from 'lucide-react';
import { Footer } from './Footer';
import { Header } from './Header';
type CompanyPageLayoutProps = {
  eyebrow: string;
  title: string;
  intro: string;
  children: React.ReactNode;
};
export function CompanyPageLayout({
  eyebrow,
  title,
  intro,
  children
}: CompanyPageLayoutProps) {
  return <div className="min-h-screen w-full bg-[#f8f5ed] text-[#17362e]" data-id="element-165">
      <Header data-id="element-166" />
      <main data-id="element-167">
        <header className="bg-[#17362e] px-5 py-16 text-white sm:px-8 lg:px-12 lg:py-24" data-id="element-168">
          <div className="mx-auto max-w-[1180px]" data-id="element-169">
            <p className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.27em] text-[#c8dfbd]" data-id="element-170">
              <CompassIcon className="h-4 w-4" aria-hidden="true" data-id="element-171" />
              Company · {eyebrow}
            </p>
            <h1 className="mt-5 max-w-4xl font-serif text-5xl leading-[0.98] sm:text-6xl lg:text-7xl" data-id="element-172">
              {title}
            </h1>
            <p className="mt-7 max-w-2xl text-lg leading-8 text-white/75" data-id="element-173">
              {intro}
            </p>
          </div>
        </header>
        {children}
      </main>
      <Footer data-id="element-174" />
    </div>;
}